import MilestoneRow from "./components/MilestoneRow";
import MetaDetails from "./components/MetaDetails";
import ChangeRequestPayouts from "./ChangeRequestPayouts";

const ChangeRequestReview = ({ data , projectDetails}) => {
  return (
    <div style={{ display: "flex", flexDirection: "column", gap: "20px" }}>
      <MetaDetails data={data} projectDetails={projectDetails}/>
      <div style={{ fontSize: "16px", fontWeight: "500" }}>Milestones & Budget Items</div>
      {data?.newMilestoneDetails && (
        <MilestoneRow
          milestone={data?.newMilestoneDetails?.proposalMilestone}
          budgets={data?.newMilestoneDetails?.proposalBudgetItems}
          typeText="New"
          type="primary"
        />
      )}
      <div style={{ height: "1px", width: "100%", background: "#d7d8d9" }} />
      {data?.oldMilestoneDetails && (
        <MilestoneRow
          milestone={data?.oldMilestoneDetails?.proposalMilestone}
          budgets={data?.oldMilestoneDetails?.proposalBudgetItems}
          typeText="Old"
          type="error"
        />
      )}
      <div style={{ display: "flex", flexDirection: "column", marginTop: "20px" }}>
        <div style={{ fontSize: "16px", fontWeight: "500" }}>Payouts</div>
        <ChangeRequestPayouts />
      </div>
    </div>
  );
};

export default ChangeRequestReview;
